import React from "react";

import { Container } from "@/Components/ui";

type GroupReservationPageShellProps = {
  children: React.ReactNode;
  className?: string;
};

export default function GroupReservationPageShell({
  children,
  className = "",
}: GroupReservationPageShellProps) {
  return (
    <div className={`page-content group-reservation-page ${className}`.trim()}>
      <Container fluid>{children}</Container>
    </div>
  );
}
